import { Accordion } from 'react-bootstrap';
import React, { useState } from 'react'; // Import useState hook for managing state
import { Checkbox } from '@mui/material';
import { AccordianProps } from './accordian.props';
import 'bootstrap/dist/css/bootstrap.css';
import './accordian.css';

function Accordian({
  title,
  includeCheckboxInTitle,
  children,
  setCheckbox,
  checked,
  partial,
  noShadow,
  bgWhite,
}: AccordianProps) {
  const [isOpen, setIsOpen] = useState(false); // State to manage accordion open/close

  const toggleAccordion = () => {
    setIsOpen(!isOpen); // Toggle the state
  };

  const handleCheckboxClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, titleVal: string) => {
    setCheckbox?.(e, titleVal);
  };

  return (
    <Accordion flush className={`mb-2 ${noShadow ? '' : 'shadow-md'}`}>
      <Accordion.Item eventKey="0">
        <Accordion.Header
          className="accordian-header font-medium text-base mt-2"
          onClick={toggleAccordion}
        >
          {includeCheckboxInTitle && (
            <Checkbox
              disableRipple
              sx={{
                padding: '2px',
                '& .MuiSvgIcon-root': { fontSize: 18 },
              }}
              className="hover:cursor-pointer"
              checked={checked}
              name={title}
              id="check"
              indeterminate={partial}
              onClick={handleCheckboxClick}
              onChange={(e) => handleCheckboxChange(e, title)}
            />
          )}
          <span className="ml-2 text-[#6A6A6A] text-sm font-medium bg-white">{title}</span>
        </Accordion.Header>
        {/* Use conditional rendering to show body based on accordion state */}
        {isOpen && (
          <Accordion.Body className={`${bgWhite ? 'bg-white' : 'bg-[#F7F7F7]'} rounded-md`}>
            {children}
          </Accordion.Body>
        )}
      </Accordion.Item>
    </Accordion>
  );
}

export default Accordian;
